module.exports = new __parcel__URL__("Ed.d7b4103d.svg").toString();